import React from "react";
import { Box, Flex } from "../../assets/ui";
import {
  Benefits1Icon,
  Benefits2Icon,
  Benefits3Icon,
  Benefits4Icon
} from "../../assets/icons";

import {
  StyledBenefitsList,
  StyledSectionWrapper,
  StyledDescription
} from "./ui";

const PrivateHostingFeatures = () => {
  return (
    <StyledSectionWrapper>
      <h2>Benefits</h2>

      <Flex>
        <StyledBenefitsList>
          <div className="benefit">
            <span>
              <Benefits1Icon />
            </span>
            <Box>
              <h4>Cancellation Protection</h4>
              <p>
                Stop losing out from cancellations, choose from our 4 policies.
              </p>
            </Box>
          </div>
          <div className="benefit">
            <span>
              <Benefits3Icon />
            </span>
            <Box>
              <h4>Availability</h4>
              <p>With live syncing you will only get booked when you want.</p>
            </Box>
          </div>
          <div className="benefit">
            <span>
              <Benefits2Icon />
            </span>
            <Box>
              <h4>Personal booking App</h4>
              <p>Give your clients the ultimate bookig experience.</p>
            </Box>
          </div>

          <div className="benefit">
            <span>
              <Benefits4Icon />
            </span>
            <Box>
              <h4>Global network</h4>
              <p>
                Access a world of new customers by joing the exsportia network.
              </p>
            </Box>
          </div>
        </StyledBenefitsList>

        <StyledDescription>
          With complete all-round customisations our software can be adapted for
          any teacher and any environment.
        </StyledDescription>
      </Flex>
    </StyledSectionWrapper>
  );
};

export default PrivateHostingFeatures;
